import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaCar, FaStar } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import rupeeFormat from 'components/Api/RupeeFormat';


const PackageCard = ({ pkg }) => {
    const data = pkg?.feed;
    if (!data) return null;

    return (
        <Card className="shadow-sm rounded-4 overflow-hidden border-0 my-3 w-100 hover-shadow">
            {/* Image & Overlays */}
            <div className="position-relative">
                <Link to={`/package/${data?.partner?.slug}/${data.package_slug}`}>
                    <Card.Img
                        variant="top"
                        src={data.image_path || '/img/placeholder.jpg'}
                        alt={data.package_display_name || 'Package'}
                        style={{ height: '200px', objectFit: 'cover' }}
                    />
                </Link>

                {/* Price Badge - Top Right */}
                {data.total_price && (
                    <div
                        className="position-absolute top-0 end-0 px-2 py-1 fw-bold text-white"
                        style={{
                            backgroundColor: '#F44D1E',
                            fontSize: '14px',
                            margin: '8px',
                            borderRadius: '30px',
                        }}
                    >
                        ₹ {rupeeFormat(data.total_price)}
                    </div>
                )}

                {/* Overlay Icons */}
                <Row
                    className="position-absolute bottom-0 w-100 text-white g-0"
                    style={{ background: '#09422d', padding: '8px 12px' }}
                >
                    <Col className="text-center">
                        <div><i className="fa-solid fa-cloud-moon fa-lg"></i></div>
                        <div style={{ fontSize: '12px' }}>{data.package_day_night_labels || '-'}</div>
                    </Col>
                    <Col className="text-center">
                        <div><FaCar size={18} /></div>
                        <div style={{ fontSize: '12px' }}>{data.no_of_safari || 0} Safaris</div>
                    </Col>
                    <Col className="text-center">
                        <div><i className="fa-solid fa-building fa-lg"></i></div>
                        <div style={{ fontSize: '12px' }}>{data.stay_category || 'Standard'}</div>
                    </Col>
                </Row>
            </div>

            {/* Content */}
            <Card.Body className="p-3">
                <h6 className="fw-bold mb-1">
                    {data.package_display_name || 'Untitled Package'}
                </h6>
                <Link to={`/park/${data?.primary_park_slug}`}>
                    <div className="text-secondary mb-2" style={{ fontSize: '13px' }}>
                        <FaLocationDot className="me-1" />
                        {data.primary_park || 'Unknown Location'}
                    </div>
                </Link>

                {/* Operator Info */}
                <div className="d-flex align-items-center border-top pt-2 mt-2">
                    <img
                        src={data?.image_path || '/img/placeholder.jpg'}
                        alt="Operator"
                        style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            objectFit: 'cover'
                        }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/img/placeholder.jpg";
                        }}
                    />
                    <div className="ms-2">
                        <Link to={`/operator/${data?.partner?.slug}/profile/sharedsafari`}>
                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#09422d' }}>
                                {data?.partner?.business_name || 'Operator'}
                            </div>
                        </Link>
                        <div className="text-muted d-flex align-items-center" style={{ fontSize: '13px' }}>
                            {Number(data?.partner?.google_rating || 0).toFixed(1)}
                            <FaStar className="text-warning ms-1 me-1" />
                            <FaStar className="text-warning ms-1 me-1" />
                            <FaStar className="ms-1 me-1" />
                            <FaStar className="ms-1 me-1" />
                            <FaStar className="ms-1 me-1" />
                            {data?.partner?.google_review_count || 0} Reviews
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PackageCard;
